import { RouteRecordRaw } from 'vue-router';
import { IRouteMeta } from '@/core/models/routing';
import { AppCoreEnums } from '@/core/shared/enums';
import { AppPermissions } from '@/shared/permissions';
import useCoreUtils from '@/core/composable/use-core-utils';

const ROUTE_CONFIGURATIONS_ROOT = 'configurations-root';
const ROUTE_CONFIGURATIONS = 'configurations';
const ROUTE_CONFIGURATIONS_DETAILS = 'configurations-details';
const ROUTE_CONFIGURATION_OVERVIEW = 'configuration-overview';
const { propertyOf } = useCoreUtils();

const configurationsRoutes: RouteRecordRaw = {
  name: ROUTE_CONFIGURATIONS,
  path: ROUTE_CONFIGURATIONS,
  component: () => import('src/pages/configurations/configurations-page.vue'),
  meta: <IRouteMeta>{
    resolve: () => Promise.all([]),
    containerType: AppCoreEnums.ContainerType.CollapsibleTableContainer,
  },
};

export { configurationsRoutes, ROUTE_CONFIGURATIONS, ROUTE_CONFIGURATIONS_ROOT, ROUTE_CONFIGURATIONS_DETAILS, ROUTE_CONFIGURATION_OVERVIEW };
